import React from "react";
import SmallSpinner from "../../loading/SmallSpinner";
import Tippy from "@tippyjs/react";
import Icon1 from "../../icons/Icon";
import { EasySwitch } from "../../textfields/EasySwitch";

const FolderAdminTable = ({
  persons,
  admins_id,
  handleAdminChange,
  loading,
  folderData,
}) => {
  // Handle the toggle for each access switch
  const handleToggle = (person_id) => {
    handleAdminChange(person_id);
  };

  return (
    <div className="text-h3 border-1 border-x-shadow_10 rounded-xl p-2 mt-1">
      <div className="flex flex-col gap-2">
        <div className="flex flex-row gap-2 font-semibold">
          <div className="flex flex-row min-w-c300 w-c300">
            <div className="flex flex-row gap-2 text-h3 items-center">
              Droits administateurs{" "}
              <span className="text-shadow_50 font-normal">
                (sous traitance)
              </span>
            </div>{" "}
          </div>
        </div>

        <div className="flex flex-col gap-1">
          {persons
            .filter(
              (person) =>
                person.id !== "particulier" &&
                person.id !== folderData.client_id
            )
            .map((person, personIndex) => (
              <div
                className="flex flex-row hover:bg-slate-50"
                key={personIndex}
              >
                <div className="flex w-c300 min-w-c300">{person.name}</div>
                <div className="w-full flex flex-row justify-end">
                  <div className="w-full flex flex-row justify-end">
                    <Tippy
                      content={
                        admins_id && admins_id.includes(person.id)
                          ? "Accès donné"
                          : "Accès retiré"
                      }
                      className="custom-tooltip"
                      delay={500}
                    >
                      <div>
                        <EasySwitch
                          checked={admins_id && admins_id.includes(person.id)}
                          disabled={loading === "all" || loading === person.id}
                          onChange={() => handleToggle(person.id)}
                        />
                      </div>
                    </Tippy>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default FolderAdminTable;
